import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    lang:'zh',
    siteInfo:{},
    companyInfo:{},
    productCategorys: [],
    topProductCategorys: [],
    solutionCategorys:[],
    serviceCategorys:[],
    products: [],
    news: [],
    solutions: [],
    breadcrumdData: []
  },
  mutations: {
    SET_LANGUAGE(state,lang){
      state.lang = lang
    },
    SET_SITEINFO(state, siteInfo) {
      state.siteInfo = siteInfo
    },
    SET_COMPANYINFO(state, companyInfo) {
      state.companyInfo = companyInfo
    },
    SET_PRODUCTCATEGORYS(state, productCategorys) {
      state.productCategorys = productCategorys
    },
    SET_SOLUTIONCATEGORYS(state, solutionCategorys) {
      state.solutionCategorys = solutionCategorys
    },
    SET_SERVICECATEGORYS(state, serviceCategorys) {
      state.serviceCategorys = serviceCategorys
    },
    SET_TOPPRODUCTCATEGORYS(state, topProductCategorys) {
      state.topProductCategorys = topProductCategorys
    },
    SET_PRODUCTS(state, products) {
      state.products = products
    },
    SET_NEWS(state, news) {
      state.news = news
    },
    SET_SOLUTIONS(state, solutions) {
      state.solutions = solutions
    },
    SET_breadcrumbData(state, breadcrumbData) {
      state.breadcrumbData = breadcrumbData
    }
  },
  actions: {
     setLanguage({ commit }, lang) {
      commit('SET_LANGUAGE', lang)
    }, 
    setSiteInfo({ commit }, siteInfo) {
      commit('SET_SITEINFO', siteInfo)
    }, 
    setCompanyInfo({ commit }, companyInfo) {
      commit('SET_COMPANYINFO', companyInfo)
    },
    setProductCategorys({ commit }, productCategorys) {
      commit('SET_PRODUCTCATEGORYS', productCategorys)
    }, 
    setSolutionCategorys({ commit }, solutionCategorys) {
      commit('SET_SOLUTIONCATEGORYS', solutionCategorys)
    },
    setServiceCategorys({ commit }, serviceCategorys) {
      commit('SET_SERVICECATEGORYS', serviceCategorys)
    },
    setTopProductCategorys({ commit }, topProductCategorys) {
      commit('SET_TOPPRODUCTCATEGORYS', topProductCategorys)
    },
    setProducts({ commit }, products) {
      commit('SET_PRODUCTS', products)
    },
    setNews({ commit }, news) {
      commit('SET_NEWS', news)
    },
    setSolutions({ commit }, solutions) {
      commit('SET_SOLUTIONS', solutions)
    },
    setBreadcrumdData({ commit }, breadcrumbData) {
      commit('SET_breadcrumdData', breadcrumbData)
    },
  },
  getters: {
    
    getLanguage:state => state.lang,
    getSiteInfo:state => state.siteInfo,
    getCompanyInfo:state => state.companyInfo,
    getTopProductCategorys: state => state.topProductCategorys,
    getProductCategorys: state => state.productCategorys,
    getSolutionCategorys: state => state.solutionCategorys,  
    getServiceCategorys: state => state.serviceCategorys,
    getProducts: state => state.products,
    getNews: state => state.news,
    getSolutions: state => state.solutions,
    getBreadcrumbData: state => state.breadcrumbData
  }
}) 